import { useEffect, useState } from "react";
import ButtonIcon from "../common/buttonIcon";
import Textarea from "../common/textArea";
import TitleModal from "../common/titleModal";
import ButtonWhite from "../common/buttonWhite";
import ButtonSubmit from "../common/buttonSubmit";
import SuccessMessageBox from "../common/successMessageBox";
import ErrorMessageBox from "../common/errorMessageBox";
import { HttpService } from "../../services/HttpService";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Spinner from "../common/spinner";

const PopUpNote = (props: any) => {

  let show = props.show ?? true;
  let bookingId = props.bookingId ?? "";
  let attendanceFullName = props.attendanceFullName ?? "";
  let eventId = props.eventId;
  const { t } = useTranslation();
  const [note, setNote] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [spinnerUpdate, setSpinnerUpdate] = useState(false);

  const [spinnerLoadNote, setspinnerLoadNote] = useState(false);
  const closePopUp = () => {
    props.closePopUp();
    resetMessage()
  }

  const loadNote = async () => {
    try {
      resetMessage()
      setspinnerLoadNote(true);
      const result = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/booking-other-information/${bookingId}`)
      setNote(result.data?.note ?? "");
      setspinnerLoadNote(false);
    }
    catch (error: any) {
      console.log(error.response.data.result);
      setErrorMessage(t(`error.${error.response.data.result.key || "generic"}`))
      setspinnerLoadNote(false)
    }
  }

  const resetMessage = () => {
    setSuccessMessage("");
    setErrorMessage("");
  }
  const updateNote = async () => {
    try {
      resetMessage();
      setSpinnerUpdate(true);
      let params = {
        note: note
      }
      const result = await HttpService.put(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/booking-other-information/${bookingId}`, params)
      setSuccessMessage(t(`success-message.NOTE_UPDATED`));
      setSpinnerUpdate(false);
    }
    catch (error: any) {
      console.log(error.response.data.result);
      setErrorMessage(t(`error.${error.response.data.result.key || "generic"}`))
      setSpinnerUpdate(false);
    }
  }

  useEffect(() => {
    if (bookingId) {
      loadNote();
    }
  }, [bookingId])

  return (
    <div className={`PopUpManagerTimeslot ${((show) ? 'active' : '')}`}>
      <div className="col-lg-12 content">
        <div className="TitleHeader">
          <div className="row m-0">
            <div className="col-10 p-0 text-left">
              <h6 className="pt-1">{attendanceFullName}</h6>
              <p className="m-0">#{bookingId}</p>
            </div>
            <div className="col-2">
              <ButtonIcon handleClick={closePopUp} icon="close" />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 p-0">
        <hr />
      </div>
      <div className="col-12 p-4 positionRelative">
        {((spinnerLoadNote) ?
          <div className="text-center">
            <Spinner />
          </div>
          :
          <>
            <TitleModal title={t('insert-note')} />
            <Textarea maxLength={200} showCharacters={true} value={note} handleChange={setNote} />
            <SuccessMessageBox successMessage={successMessage} />
            <ErrorMessageBox errorMessage={errorMessage} />
            <div className="footer bottom">
              <div className="row m-0">
                <div className="col-lg-6 p-2">
                  <ButtonWhite textButton={t('cancel')} handleChange={closePopUp} />
                </div>
                <div className="col-lg-6 p-2">
                  <ButtonSubmit textButton={t('save')} spinner={spinnerUpdate} handleChange={updateNote} />
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PopUpNote
